<template>
	<Card style="min-height: 500px;">
		<div>
			<Tabs value="myLog" tab="tab1">
				<TabPane label="我的日志" name="myLog" tab="tab1">
					<operateLogList ref="recordList"></operateLogList>
				</TabPane>
				<TabPane label="团队日志" name="teamLog"  tab="tab1" icon="logo-windows">
					<teamLogList ref="teamLogList"></teamLogList>
				</TabPane>
			</Tabs>
		</div>
	</Card>
</template>

<script>
	import operateLogList from "./components/operateLogList.vue"
	import teamLogList from "./components/TeamLogList.vue"
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "task",
		components: {
			operateLogList,
			teamLogList
		},
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.loadData();
		},
		data() {
			return {
				bindData: {
					status: '',
					remark: '',
				},
				activeMenu: 'myLog',
				bindRemarkData: [],
				addRecordShow: false,
				todayCustomerModal: false,
				tabs_value: 'day',
				form: {
					summarize: '',
					issue: '',
				},
				staticData: {

				},
				stateList: [{
						value: 1,
						label: '未处理',
						is_true: 0
					},
					{
						value: 2,
						label: '待跟进',
						is_true: 0
					},
					{
						value: 3,
						label: '邀约中',
						is_true: 0
					},
					{
						value: 6,
						label: '上门未签约',
						is_true: 0
					},
					{
						value: 7,
						label: '已签约',
						is_true: 0
					},
					{
						value: 8,
						label: '进件中',
						is_true: 0
					},
					{
						value: 9,
						label: '银行拒绝',
						is_true: 0
					},
					{
						value: 13,
						label: '已回款',
						is_true: 0
					},
					{
						value: 14,
						label: '资质不符',
						is_true: 0
					},
					{
						value: 15,
						label: '捣乱申请',
						is_true: 0
					},
					{
						value: 16,
						label: '外地申请',
						is_true: 0
					},
					{
						value: 17,
						label: '重复申请',
						is_true: 0
					},
					{
						value: 18,
						label: '短信申请',
						is_true: 0
					}
				],
			}
		},
		methods: {
			async loadData() {
				let that = this;
				let data = {
					token: that.token,
					type: that.tabs_value
				}
			},
			save() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						type: that.tabs_value,
						form: that.form,
						staticData: that.staticData
					}
					if (that.staticData.call_nums == 0) {
						this.$Message.error('通话次数不能为空');
						return;
					}
					if (that.staticData.call_time == 0) {
						this.$Message.error('通话时长不能为空');
						return;
					}
					let res = await saveReport(that, data);
					if (res.code == 1) {
						this.form = {
							summarize: '',
							issue: '',
						};
						this.addRecordShow = false;
						this.$refs['recordList'].getList();
					}
				}, 500)
			},
			menuItemClick(e) {
				this.activeMenu = e;
				console.log(e)
			},
			AddRecordClick() {
				this.addRecordShow = true;
				this.loadData();
			},
			getTodayCustomerList() {
				this.todayCustomerModal = true;
			},
			addTabsClick(e) {
				this.loadData();
			}
		}
	}
</script>

<style scoped lang="less">
	.text-center {
		height: 580px;
		overflow: scroll;
	}

	.shijian {
		position: relative;
		left: 15px;
	}

	.xiaoxi {
		position: relative;
		left: -120px;
		top: 18px;
	}

	.icon-biao {
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}

	.xiangqing {
		background-color: #F9FAFA;
	}

	.biaoti {
		font-weight: bold;
	}

	.biaogetoubu {
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}

	.shuju {
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;

		div {
			margin-right: 20px;
			width: 60px;
		}
	}

	.biaogelimian {
		display: flex;
		justify-content: space-around;
	}

	.shanchu {
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}

	.biaotou {
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}



	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}

	.ivu-table-fixed-header thead tr th {
		text-align: center;
	}

	.list_width {
		div {
			width: 160px;
		}
	}
</style>
